import { useCallback } from 'react';
import {
  PartnerAccount,
  PartnerProfile,
} from 'types';
import { Paper } from '@mui/material';
import useStyles from './PartnerListItem.styles';
import { FilledButton, Image } from 'components';
import { navigateToPartnerContents } from 'utils/history';
import { useSelectedLinkContext } from 'contexts';

type PartnerListItemPureProps = {
  partnerProfile: PartnerProfile;
  handlePartnerItemClick: () => void;
};

const PartnerListItemPure = ({
  partnerProfile,
  handlePartnerItemClick,
}: PartnerListItemPureProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Paper className={classes.container}>
      <Image
        className={classes.image}
        src={partnerProfile.thumbnailBlob.s3URL}
      />

      <div className={classes.name}>{partnerProfile.name}</div>

      <FilledButton
        className={classes.button}
        color="green"
        onClick={handlePartnerItemClick}
      >
        Découvrir
      </FilledButton>
    </Paper>
  );
};

type PartnerListItemProps = {
  partnerAccount: PartnerAccount;
};

const PartnerListItem = ({
  partnerAccount,
}: PartnerListItemProps): JSX.Element => {
  const { selectedLink } = useSelectedLinkContext();

  const handlePartnerItemClick = useCallback(
    () => navigateToPartnerContents(selectedLink, partnerAccount.id),
    [partnerAccount, selectedLink],
  );

  return (
    <PartnerListItemPure
      partnerProfile={partnerAccount.partnerProfile}
      handlePartnerItemClick={handlePartnerItemClick}
    />
  );
};

export default PartnerListItem;
